<div class="form-inline" *ngIf="tool.activated$ | async">
  <div class="input-group size-chooser">
    <span class="input-group-btn">
      <button
        class="btn btn-default"
        type="button"
        (click)="tool.finer()"
        matTooltip="Smaller"
      >
        <fa-icon [icon]="faTh" [fixedWidth]="true"></fa-icon>
      </button>
    </span>
    <!-- ranges don't like being styled, so style a wrapper -->
    <span class="form-control">
      <input
        type="range"
        [min]="tool.selectedAlgorithm.minRelativeSize"
        [max]="tool.selectedAlgorithm.maxRelativeSize"
        [ngModel]="tool.relativeSize"
        (ngModelChange)="tool.setSize($event)"
      />
    </span>
    <span class="input-group-btn">
      <button
        class="btn btn-default"
        type="button"
        (click)="tool.coarser()"
        matTooltip="Bigger"
      >
        <fa-icon [icon]="faSquare" [fixedWidth]="true"></fa-icon>
      </button>
    </span>
  </div>

  <select [(ngModel)]="tool.selectedAlgorithm" class="form-control">
    <option
      *ngFor="let algorithm of tool.algorithms"
      [ngValue]="algorithm"
      [label]="algorithm.name"
    ></option>
  </select>
</div>
